import { z as documentCreateElement, f as fails, m as globalThis_1, c as createNonEnumerableProperty, d as anObject, h as getMethod, a as functionCall, w as wellKnownSymbol, k as descriptors, s as objectDefineProperty, p as createPropertyDescriptor, x as isNullOrUndefined, A as aCallable, B as tryToString, t as toObject, b as functionUncurryThis, e as requireObjectCoercible, C as sharedKey, q as hasOwnProperty_1, i as isCallable, g as isObject, D as functionName, o as internalState, E as environmentUserAgent, F as environmentV8Version } from './index-f674799c.js';
import { c as arrayIteration, d as isConstructor, b as functionBindContext, i as isArray } from './es.object.to-string-2822ee1b.js';
import { a as arrayMethodHasSpeciesSupport } from './es.array.filter-3afc328b.js';
import { j as classof, l as lengthOfArrayLike, _ as _export, t as toString_1, b as toIntegerOrInfinity, d as defineBuiltIn, f as toIndexedObject, e as toAbsoluteIndex, n as arrayIncludes, c as classofRaw } from './to-string-6d234645.js';
import { a as objectCreate, o as objectKeys } from './object-create-ee21b296.js';
import { s as setToStringTag, b as arraySlice, a as addToUnscopables } from './es.array.find-55b4ab5e.js';
import { o as objectSetPrototypeOf } from './object-set-prototype-of-1688b6af.js';
import { toRefs, ref, computed, watch, onMounted, readonly, resolveComponent, resolveDirective, openBlock, createElementBlock, normalizeClass, Fragment, withDirectives, createCommentVNode, createVNode, createElementVNode, vShow, toDisplayString } from 'vue';
import { useField } from 'vee-validate';
import Select2 from 'vue3-select2-component';
import { u as useToggler } from './useToggler-e9ff86c0.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;


var STRICT_METHOD$1 = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$1 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
};

for (var COLLECTION_NAME in domIterables) {
  if (domIterables[COLLECTION_NAME]) {
    handlePrototype(globalThis_1[COLLECTION_NAME] && globalThis_1[COLLECTION_NAME].prototype);
  }
}

handlePrototype(domTokenListPrototype);

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var iterators = {};

var ITERATOR$4 = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR$4] === it);
};

var createProperty = function (object, key, value) {
  if (descriptors) objectDefineProperty.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

var ITERATOR$3 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$3)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var $TypeError$2 = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw new $TypeError$2(tryToString(argument) + ' is not iterable');
};

var $Array$1 = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array$1 && isArrayIteratorMethod(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    for (;!(step = functionCall(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$1(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
_export({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: arrayFrom
});

var charAt$1 = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var stringSlice = functionUncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var ITERATOR$1 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$1].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype$2[ITERATOR$1])) {
  defineBuiltIn(IteratorPrototype$2, ITERATOR$1, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return { value: value, done: done };
};

var charAt = stringMultibyte.charAt;





var STRING_ITERATOR = 'String Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
iteratorDefine(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString_1(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return arraySlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var $TypeError$1 = TypeError;

var deletePropertyOrThrow = function (O, P) {
  if (!delete O[P]) throw new $TypeError$1('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var floor = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort = sort;

var firefox = environmentUserAgent.match(/firefox\/(\d+)/i);

var environmentFfVersion = !!firefox && +firefox[1];

var environmentIsIeOrEdge = /MSIE|Trident/.test(environmentUserAgent);

var webkit = environmentUserAgent.match(/AppleWebKit\/(\d+)\./);

var environmentWebkitVersion = !!webkit && +webkit[1];

var test = [];
var nativeSort = functionUncurryThis(test.sort);
var push = functionUncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (environmentV8Version) return environmentV8Version < 70;
  if (environmentFfVersion && environmentFfVersion > 3) return;
  if (environmentIsIeOrEdge) return true;
  if (environmentWebkitVersion) return environmentWebkitVersion < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1(x) > toString_1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    arraySort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var $findIndex = arrayIteration.findIndex;


var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var $includes = arrayIncludes.includes;



// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var MATCH$1 = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classofRaw(it) === 'RegExp');
};

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var stringIndexOf = functionUncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString_1(requireObjectCoercible(this)),
      toString_1(notARegexp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var $map = arrayIteration.map;


var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

library.add(faQuestionCircle);
var script = {
  name: 'form-control-select',
  emits: ['validate', 'selected'],
  props: {
    name: {
      required: true,
      type: String
    },
    code: {
      required: false,
      type: String,
      default: ''
    },
    showLabel: {
      required: false,
      type: Boolean,
      default: false
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    options: {
      required: false,
      type: Array,
      default: function _default() {
        return [];
      }
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    multiselect: {
      required: false,
      type: Boolean,
      default: false
    },
    defaultvalue: {
      required: false,
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    cachevalue: {
      required: false,
      type: Array,
      default: function _default() {
        return [];
      }
    },
    shouldcache: {
      required: false,
      type: Boolean,
      default: false
    },
    additionalLabelClasses: {
      required: false,
      type: String,
      default: ''
    },
    prefixId: {
      required: false,
      type: String,
      default: 'wdw-form-attr'
    },
    error: {
      required: false,
      type: String,
      default: ''
    },
    serverError: {
      required: false,
      type: String,
      default: ''
    },
    help: {
      required: false,
      type: String,
      default: ''
    },
    hidden: {
      required: false,
      type: Boolean,
      default: false
    },
    visibleIfResult: {
      required: false,
      type: Boolean,
      default: true
    },
    disabled: {
      default: false,
      type: Boolean
    },
    allowClear: {
      required: false,
      type: Boolean,
      default: false
    },
    isPublic: {
      type: Boolean,
      default: true
    },
    reset: {
      type: Boolean,
      required: false,
      default: false
    },
    typeable: {
      type: Boolean,
      required: false,
      default: false
    },
    iconSize: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          selection: 26,
          result: 32
        };
      }
    },
    germanMessages: {
      type: Boolean,
      required: false,
      default: true
    },
    dropdownParent: {
      type: HTMLElement,
      required: false,
      default: undefined
    },
    tags: {
      type: Boolean,
      required: false,
      default: false
    },
    overridevalue: {
      // Use this to override value (e.g. when parent wants to change the value of this component)
      // Only triggered if the overridden value is different than actual value
      required: false,
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dependantvalues: {
      // T22832: Contains the key-value pairings of other <select> result
      // This determines which options that can be shown in the selection based on other <select>'s values
      // Example: { 'code1': ['value1', 'value2'], 'code2': [ 'value3' ], .... }
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    additionalSettings: {
      // Select2 settings (e.g. templateResult, ajax, etc)
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props, context) {
    var _toRefs = toRefs(props),
        name = _toRefs.name,
        required = _toRefs.required,
        code = _toRefs.code,
        defaultvalue = _toRefs.defaultvalue,
        cachevalue = _toRefs.cachevalue,
        shouldcache = _toRefs.shouldcache,
        label = _toRefs.label,
        options = _toRefs.options,
        prefixId = _toRefs.prefixId,
        multiselect = _toRefs.multiselect,
        error = _toRefs.error,
        serverError = _toRefs.serverError,
        allowClear = _toRefs.allowClear,
        additionalLabelClasses = _toRefs.additionalLabelClasses,
        isPublic = _toRefs.isPublic,
        reset = _toRefs.reset,
        typeable = _toRefs.typeable,
        dropdownParent = _toRefs.dropdownParent,
        tags = _toRefs.tags; // Contains JS DOM object for select2 container label


    var select2 = ref(null);
    var select2Elem = null;
    var select2ElemBox = null;

    var _useToggler = useToggler(),
        shouldShowHelp = _useToggler.toggleValue,
        toggleHelpText = _useToggler.toggle;

    var filteredSelect2Options = ref([]);
    var lastCheckedDependantKeyValue = ref(null); //+---------------------+
    //|    early computed() |
    //+---------------------+

    var idInput = computed(function () {
      return prefixId.value + '-select-' + name.value;
    }); //+---------------------+
    //|    Other functions  |
    //+---------------------+

    function updateSelect2AriaLabel() {
      if (label && label.value !== '' && select2Elem !== null) {
        var s2e = select2Elem;
        var sel2SingleSearch = s2e.querySelectorAll('.select2-selection--single')[0];
        var sel2Rendered = s2e.querySelectorAll('.select2-selection__rendered')[0]; // For single search

        if (sel2SingleSearch) {
          sel2SingleSearch.removeAttribute('aria-labelledby');
          sel2SingleSearch.removeAttribute('aria-describedby ');
          sel2SingleSearch.setAttribute('aria-label', label.value + ' ' + sel2Rendered.textContent);
        } // For multiselect with text input field


        var sel2MultiselectedValues = s2e.querySelectorAll('.select2-selection__choice');
        var sel2MultiselectInput = s2e.querySelectorAll('.select2-search__field');

        if (sel2MultiselectInput.length > 0 && sel2MultiselectedValues) {
          var pickedValues = '';
          sel2MultiselectedValues.forEach(function (sel) {
            pickedValues += sel.getAttribute('title') + ', ';
          });
          sel2MultiselectInput[0].setAttribute('aria-label', label.value + ': ' + pickedValues);
        }
      }
    }

    function initSelect2() {
      var _selectElem$parentNod;

      var selectElem = document.getElementById(idInput.value);
      var select2ElemsArray = selectElem === null || selectElem === void 0 ? void 0 : (_selectElem$parentNod = selectElem.parentNode) === null || _selectElem$parentNod === void 0 ? void 0 : _selectElem$parentNod.children;

      if (selectElem && select2ElemsArray) {
        //for-loop is needed for library to bundle correctly
        for (var i = 0; i < select2ElemsArray.length; i++) {
          if (select2ElemsArray[i].classList.contains('select2-container--default')) {
            select2Elem = select2ElemsArray[i];
            select2ElemBox = select2ElemsArray[i].childNodes[0].childNodes[0];
          }
        }

        updateSelect2AriaLabel();
      }
    }

    function getOptionByValue(optValue) {
      if (optValue == '') return null;
      var selected = options.value.filter(function (opt) {
        return opt.id === optValue;
      });
      return selected.length == 0 ? null : selected[0];
    }

    function validate(value) {
      var finalvalue = [];

      if (value !== null) {
        finalvalue = Array.isArray(value) ? value : Array.from([value]);
      }

      var returnValue = {
        value: finalvalue,
        valueHuman: [],
        validated: true,
        name: name.value,
        code: code.value,
        type: 'valuelist'
      };
      finalvalue.forEach(function (v) {
        var optVal = getOptionByValue(v);

        if (optVal !== null) {
          var optValHuman = readonly(optVal);

          if (optValHuman && optValHuman.text) {
            returnValue.valueHuman.push(optValHuman.text);
          }
        }
      });

      if (required.value) {
        returnValue.validated = finalvalue.length > 0 && finalvalue[0] !== '';
      } else {
        returnValue.validated = true;
      }

      if (shouldcache.value) {
        localStorage.setItem(name.value, String(returnValue.value));
      } // Update labelling for accessibility


      updateSelect2AriaLabel(); // Update display for select2ElemBox

      if (select2ElemBox) {
        select2ElemBox.style['border-color'] = returnValue.validated ? '#000' : '#f00';
      } // Emit event


      context.emit('validate', returnValue);
      return returnValue.validated ? true : error.value;
    }

    var initialValue = shouldcache.value && cachevalue.value && cachevalue.value.length > 0 ? cachevalue.value : defaultvalue.value;

    var _useField = useField(name, validate, {
      initialValue: initialValue
    }),
        errorMessage = _useField.errorMessage,
        value = _useField.value;

    function select2SelectEvent() {
      // do not emit direct select2 event. Event does not contain empty value when selection was cleared
      // instead find select element and emit current value
      if (select2Elem) {
        var selectElem = document.getElementById(idInput.value);

        if (selectElem) {
          context.emit('selected', {
            field: name.value,
            value: selectElem.value
          });
        }
      }
    }

    function onSelect2Opened() {
      var searchField = document.querySelector(".select2-search__field");
      console.log("onSelect2Opened", searchField);

      if (searchField) {
        searchField.focus();
      }
    }

    function resetSelect() {
      value.value = [];
      validate(value.value);
    }

    function setValue(string) {
      value.value = string;
      validate(string);
    }

    context.expose({
      resetSelect: resetSelect,
      setValue: setValue,
      name: name,
      value: value
    }); //+---------------------+
    //|    computed()       |
    //+---------------------+

    var hasError = computed(function () {
      return errorMessage.value != undefined;
    });
    var hasServerError = computed(function () {
      return serverError.value != undefined && serverError.value !== '';
    });
    var wrapperClassName = computed(function () {
      return {
        'form-group': true,
        'has-danger': hasError.value || hasServerError.value
      };
    });
    var labelClassName = computed(function () {
      return additionalLabelClasses.value + ' ' + (hasError.value || hasServerError.value ? 'text-danger' : '');
    });
    var labelText = computed(function () {
      return label.value + (required.value ? '*' : '') + (isPublic.value ? '' : ' - <span class="text-muted">Diese Daten werden nicht veröffentlicht.</span>');
    });
    var select2Options = computed(function () {
      // We need to check whether select2Elem is initialized first
      // For some cases, computed() can be called even before select2 component is mounted
      if (select2Elem === null) {
        var result = options.value.slice();
        return result;
      }

      var s2Options = options.value.slice();

      if (defaultvalue.value.length == 0 && !multiselect.value) {
        s2Options.unshift({
          id: '',
          text: 'Bitte wählen Sie'
        });
      }

      return s2Options;
    });

    function replaceTemplate(item, iconSize) {
      if (item.text && item.url) {
        var img = document.createElement('img');
        img.src = item.url;
        img.alt = item.text;
        img.width = iconSize;
        return img;
      } else {
        return item.text;
      }
    }

    function arrayEquals(a, b) {
      if (!a || !b) {
        return false;
      }

      if (!Array.isArray(a)) {
        a = [a];
      }

      if (!Array.isArray(b)) {
        b = [b];
      }

      var sortedCopyA = JSON.parse(JSON.stringify(a)).sort();
      var sortedCopyB = JSON.parse(JSON.stringify(b)).sort();
      return Array.isArray(sortedCopyA) && Array.isArray(sortedCopyB) && sortedCopyA.length === sortedCopyB.length && sortedCopyA.every(function (val, index) {
        return val === sortedCopyB[index];
      });
    }

    function replaceTemplateResult(item) {
      return replaceTemplate(item, props.iconSize ? props.iconSize.result : 26);
    }

    function replaceTemplateSelection(item) {
      return replaceTemplate(item, props.iconSize ? props.iconSize.selection : 32);
    }

    var select2Settings = computed(function () {
      var settings = _objectSpread2({
        templateResult: replaceTemplateResult,
        templateSelection: replaceTemplateSelection,
        tags: tags.value,
        multiple: multiselect.value,
        selectionCssClass: 'wdw-select2',
        // this does not work in v-select2-component, but is the correct approach according to docs
        containerCssClass: 'wdw-select2',
        // this works but is a bug as it's supposed to set the class on the container
        width: '100%',
        placeholder: label.value,
        minimumResultsForSearch: multiselect.value ? 20 : typeable.value ? 1 : -1,
        allowClear: allowClear.value,
        language: {},
        dropdownParent: dropdownParent.value
      }, props.additionalSettings);

      props.germanMessages ? settings.language = {
        errorLoading: function errorLoading() {
          return 'Die Ergebnisse konnten nicht geladen werden.';
        },
        inputTooLong: function inputTooLong(args) {
          var overChars = args.input.length - args.maximum;
          return 'Bitte ' + overChars + ' Zeichen weniger eingeben';
        },
        inputTooShort: function inputTooShort(args) {
          var remainingChars = args.minimum - args.input.length;
          return 'Bitte ' + remainingChars + ' Zeichen mehr eingeben';
        },
        loadingMore: function loadingMore() {
          return 'Lade mehr Ergebnisse…';
        },
        maximumSelected: function maximumSelected(args) {
          var message = 'Sie können nur ' + args.maximum + ' Element';

          if (args.maximum != 1) {
            message += 'e';
          }

          message += ' auswählen';
          return message;
        },
        noResults: function noResults() {
          return 'Keine Übereinstimmungen gefunden';
        },
        searching: function searching() {
          return 'Suche…';
        },
        removeAllItems: function removeAllItems() {
          return 'Entferne alle Elemente';
        }
      } : null;
      return settings;
    });
    var idErrorText = computed(function () {
      return prefixId.value + '-select-' + name.value + '-error';
    });
    var inputHighlight = computed(function () {
      if (value.value && defaultvalue.value) {
        return {
          'input-highlight': defaultvalue.value[0] !== value.value[0] // Highlight select if a defaultvalue is present

        };
      }

      return {
        'input-highlight': false
      };
    });
    var showResetButton = computed(function () {
      var _value$value;

      return ((_value$value = value.value) === null || _value$value === void 0 ? void 0 : _value$value.length) > 0 && reset.value;
    });
    /**
     *    +-------------------------------+
     *    |       WATCHES                 |
     *    +-------------------------------+
     */
    // T22832

    watch(function () {
      return props.dependantvalues;
    }, function (nv, ov) {
      var originalOptions = select2Options.value; // If there are no options with attribute dependency we can safely ignore

      if (originalOptions.findIndex(function (x) {
        return x.filter_attr_code != null && x.filter_attr_code != '';
      }) == -1) {
        filteredSelect2Options.value = originalOptions;
        return;
      } // Check if any dependant values are changed.
      // This is required for changes on dependant values that have nothing to do with this options, but are included anyway
      // E.g in a form with field A, B, C with A dependant on B, value of field C is changed
      // If they are not changed, we don't have to refilter the options


      var dependantValuesChanged = false;

      if (lastCheckedDependantKeyValue.value != null) {
        /**
         *  nv:
         *    { 'sel1': ["a", "b"], 'sel2': ["c"], 'sel3': ["d", "e"] }
         *  lastCheckedDependantKeyValue:
         *    { 'sel1': ["a"] }
         *  intersect and compare
         *    { 'sel1': ["a", "b"] } and { 'sel1': ["a"] }
         *
         *  if the value is different (or if the select field is first initiated), the dependant value was changed and we need to evaluate the options
         */
        var intersectionKeys = Object.keys(lastCheckedDependantKeyValue.value).filter(function (k) {
          return Object.keys(nv).includes(k);
        });

        if (intersectionKeys.length > 0) {
          dependantValuesChanged = intersectionKeys.map(function (k) {
            return arrayEquals(lastCheckedDependantKeyValue.value[k], nv[k]);
          }).find(function (x) {
            return !x;
          }) != undefined;
        }
      } else {
        dependantValuesChanged = true;
      }

      if (!dependantValuesChanged) {
        return;
      }

      var filteredOpts = []; // Loop through the list of dependant values

      Object.keys(nv).forEach(function (selectItemKey) {
        // First, ignore the one with the same code (because you cannot create dependency to your own option)
        // Second, check that there is at least one option that has dependency towards attribute with key "selectItemKey"
        if (selectItemKey != code.value && originalOptions.findIndex(function (x) {
          return x.filter_attr_code == selectItemKey;
        }) >= 0) {
          // Array of value from the given dependant
          var filterValue = nv[selectItemKey]; // If the value is empty, don't filter anything. Use original options

          if (filterValue == null || filterValue == undefined || filterValue.length == 0 || filterValue[0] == '') {
            filteredOpts = originalOptions;
          } else {
            // Filter only options whose filter_attr_code matches selectItemKey and the filter_value is included
            filteredOpts = originalOptions.filter(function (org) {
              return org.filter_attr_code == selectItemKey && filterValue.includes(org.filter_value);
            }); // Store the last checked dependant key-value.

            if (lastCheckedDependantKeyValue.value == null) {
              lastCheckedDependantKeyValue.value = {};
            }

            lastCheckedDependantKeyValue.value[selectItemKey] = filterValue;
          }
        }
      }); // Compare the existing values and the filtered options. Only retain values that are available in the filtered options

      if (Array.isArray(value.value) && value.value.length > 0) {
        var filteredOptsIdOnly = filteredOpts.map(function (x) {
          return x.id;
        });
        var retainedValues = value.value.filter(function (x) {
          return filteredOptsIdOnly.includes(x);
        });
        value.value = retainedValues;
      }

      filteredSelect2Options.value = filteredOpts;
    }, // deep:true is needed because it watches a JS object
    {
      deep: true
    }); //+---------------------+
    //|  WATCHERS           |
    //+---------------------+

    watch(function () {
      return props.overridevalue;
    }, function (nv, ov) {
      if (!arrayEquals(nv, ov) && !arrayEquals(nv, value.value)) {
        value.value = nv;
      }
    }); //+---------------------+
    //|  Lifecycle Hooks    |
    //+---------------------+

    onMounted(function () {
      initSelect2();
      filteredSelect2Options.value = select2Options.value;
    });
    return {
      // Computed
      hasError: hasError,
      hasServerError: hasServerError,
      wrapperClassName: wrapperClassName,
      labelClassName: labelClassName,
      select2Options: select2Options,
      select2Settings: select2Settings,
      idInput: idInput,
      idErrorText: idErrorText,
      shouldShowHelp: shouldShowHelp,
      labelText: labelText,
      showResetButton: showResetButton,
      filteredSelect2Options: filteredSelect2Options,
      // Methods
      toggleHelpText: toggleHelpText,
      resetSelect: resetSelect,
      select2SelectEvent: select2SelectEvent,
      onSelect2Opened: onSelect2Opened,
      // VARS
      select2: select2,
      errorMessage: errorMessage,
      value: value,
      inputHighlight: inputHighlight
    };
  },
  mixins: [],
  components: {
    Select2: Select2
  }
};

var _hoisted_1 = ["for"];
var _hoisted_2 = {
  class: "alert alert-info alert-dismissible mb-2 form-info-message",
  role: "alert"
};
var _hoisted_3 = ["id"];
var _hoisted_4 = ["id"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_Select2 = resolveComponent("Select2");

  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return $props.visibleIfResult ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass([$setup.wrapperClassName, $setup.inputHighlight]),
    id: "wdw-library-form-control-select"
  }, [!$props.hidden ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [$props.showLabel ? withDirectives((openBlock(), createElementBlock("label", {
    key: 0,
    for: $setup.idInput,
    class: normalizeClass($setup.labelClassName)
  }, null, 10, _hoisted_1)), [[_directive_dompurify_html, $setup.labelText]]) : createCommentVNode("", true), $setup.showResetButton ? (openBlock(), createElementBlock("span", {
    key: 1,
    class: "btn btn-danger delete-filter",
    title: "Eingabe verwerfen",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.resetSelect && $setup.resetSelect.apply($setup, arguments);
    })
  }, " ✕ ")) : createCommentVNode("", true), $props.help ? (openBlock(), createElementBlock("span", {
    key: 2,
    class: "help-trigger",
    title: "Hilfe anzeigen",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: "question-circle",
    size: "lg"
  })])) : createCommentVNode("", true), withDirectives(createElementVNode("div", _hoisted_2, [withDirectives(createElementVNode("span", null, null, 512), [[_directive_dompurify_html, $props.help]]), createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "aria-label": "Close",
    onClick: _cache[2] || (_cache[2] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  })], 512), [[vShow, $setup.shouldShowHelp]])], 64)) : createCommentVNode("", true), createVNode(_component_Select2, {
    id: $setup.idInput,
    "data-vv-as": $setup.labelText,
    "data-wdw-code": $props.code,
    name: $props.name,
    settings: $setup.select2Settings,
    options: $setup.filteredSelect2Options,
    "aria-invalid": $setup.hasError || $setup.hasServerError,
    ref: "select2",
    class: "",
    modelValue: $setup.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $setup.value = $event;
    }),
    onSelect: $setup.select2SelectEvent,
    hidden: $props.hidden,
    disabled: $props.disabled
  }, null, 8, ["id", "data-vv-as", "data-wdw-code", "name", "settings", "options", "aria-invalid", "modelValue", "onSelect", "hidden", "disabled"]), !$props.hidden ? (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    "aria-atomic": "true",
    "aria-live": "polite",
    class: "text-danger form-error-message"
  }, toDisplayString($props.error), 9, _hoisted_3), [[vShow, $setup.hasError]]), withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    "aria-atomic": "true",
    "aria-live": "polite",
    class: "text-danger form-error-message"
  }, toDisplayString($props.serverError), 9, _hoisted_4), [[vShow, $setup.hasServerError]])], 64)) : createCommentVNode("", true)], 2)) : createCommentVNode("", true);
}

script.render = render;
script.__scopeId = "data-v-45940dd6";

export { _objectWithoutProperties as A, isArrayIteratorMethod as B, iteratorClose as C, iterators as D, domIterables as E, domTokenListPrototype as F, _toConsumableArray as _, stringMultibyte as a, arrayMethodIsStrict as b, createProperty as c, deletePropertyOrThrow as d, _inherits as e, _createSuper as f, _classCallCheck as g, _defineProperty as h, _assertThisInitialized as i, _createClass as j, _asyncToGenerator as k, correctIsRegexpLogic as l, _objectSpread2 as m, notARegexp as n, _slicedToArray as o, _createForOfIteratorHelper as p, objectGetPrototypeOf as q, _typeof as r, script as s, iteratorCreateConstructor as t, createIterResultObject as u, arraySort as v, getIteratorMethod as w, getIterator as x, checkCorrectnessOfIteration as y, iteratorDefine as z };
